import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {SiteUrls} from '../SiteUrls'
import {HanmiManagerAuthorized} from './HanmiManagerAuthorized'
import {HanmiManagerLoginPage} from './HanmiManagerLoginPage'
import {HanmiManagerLogoutPage} from './HanmiManagerLogoutPage'
import {HanmiManagerMainLayout} from './HanmiManagerMainLayout'
import {SSEProvider} from "react-hooks-sse"
import {AppOptions, LOCAL_STORAGE_KEY_TOKEN} from "../AppOptions"

const sseEndpoint = `${AppOptions.SERVER_ADDRESS}/events?token=${localStorage.getItem(LOCAL_STORAGE_KEY_TOKEN)}&clientType=HanmiManager`
export const HanmiManagerRoot: React.FC = () => {
  return (
    <Switch>
      <Route path={SiteUrls.HanmiManager.Login} component={HanmiManagerLoginPage} />
      <Route path={SiteUrls.HanmiManager.Logout} component={HanmiManagerLogoutPage} />
      <Route
        path={SiteUrls.HanmiManager.Root}
        render={() => {
          return (
            <HanmiManagerAuthorized>
              <SSEProvider endpoint={sseEndpoint}>
                <HanmiManagerMainLayout />
              </SSEProvider>
            </HanmiManagerAuthorized>
          )
        }}
      />
      <Redirect to={SiteUrls.HanmiManager.Dashboard.Main} />
    </Switch>
  )
}
